import createVueApp from '@/common/createApp'

Styxie.Initializers.GoogleAccounts = {
  index: async(props) => {
    const { default: GoogleAccountsIndex } = await import('@/vue_widgets/google_accounts/index.vue')
    createVueApp(GoogleAccountsIndex, { props })
  },
  show: async(props) => {
    const { default: GoogleAccountShow } = await import('@/vue_widgets/google_accounts/show.vue')
    createVueApp(GoogleAccountShow, { props })
  }
}
